/**
 * Check to see if a variable is numeric
 * @param n
 * @returns {boolean}
 */
export default (n) => {
    return !isNaN(parseFloat(n)) && isFinite(n);
};
